module.exports = __webpack_public_path__ + "img/icon_bucket_logo.88f442dd.svg";